module.exports = __webpack_public_path__ + "static/media/eiffel.97e5e575.jpeg";